import React from 'react'

function ShowIssuingEntities ({ label, entities }) {
  const filteredEntities = entities.filter(x => x.isImportant === 1)
  let entitiesToShow = filteredEntities.length > 0 ? filteredEntities : entities

  entitiesToShow = Array.from(new Set(entitiesToShow.map(e => e.id)))
    .map(id => {
      return entitiesToShow.find(c => c.id === id)
    })

  return (
    <>
      {(entitiesToShow && entitiesToShow.length > 0) ? (
        <>
          <strong>{label}: </strong>
          {entitiesToShow
            .map(entity => (<span key={entity.id}>{entity.title}</span>))
            .reduce((acc, x) => acc === null ? [x] : [acc, ', ', x], null)}
        </>
      ) : null}
    </>
  )
}

export default ShowIssuingEntities
